import styled from 'styled-components';

export const Card = styled.div`
  border-radius: 8px;

  .processing-icon {
    font-size: 56px;
    color: ${(props) => props.theme.$primary};
  }

  .processing-text {
    max-width: 320px;
    font-size: 16px;
    line-height: 1.4;
    color: ${(props) => props.theme.$dark};
  }
`;
